import React, { FC, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
interface CheckboxWithTooltipProps {
  open: boolean;
  large?: boolean;
  color?: 'default' | 'blue';
  arrowPlacement?: 'top' | 'bottom';
}
const Tooltip: FC<PropsWithChildren<CheckboxWithTooltipProps>> = ({
  open,
  large = false,
  color = 'default',
  arrowPlacement = 'bottom',
  children
}) => {
  if (!open) return null;
  return <TooltipWrapper color={color} large={large}>
      {children}
      <TooltipArrow color={color} arrowPlacement={arrowPlacement} large={large} />
    </TooltipWrapper>;
};
export default Tooltip;
const _exp = /*#__PURE__*/() => ({
  color,
  theme
}) => color === 'blue' ? '#007CFF' : theme.colors.icon.primary;
const _exp2 = /*#__PURE__*/() => ({
  large
}) => large ? '14px' : '12px';
const _exp3 = /*#__PURE__*/() => ({
  large
}) => large ? 'none' : 'uppercase';
const _exp4 = /*#__PURE__*/() => ({
  large
}) => large ? '10px 12px' : '4px 8px';
const _exp5 = /*#__PURE__*/() => ({
  large
}) => large ? '12px' : '8px';
const TooltipWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "TooltipWrapper",
  class: "ta8szkh",
  propsAsIs: false,
  vars: {
    "ta8szkh-0": [_exp()],
    "ta8szkh-1": [_exp2()],
    "ta8szkh-2": [_exp3()],
    "ta8szkh-3": [_exp4()],
    "ta8szkh-4": [_exp5()]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  arrowPlacement
}) => arrowPlacement === 'bottom' ? '100%' : 'auto';
const _exp7 = /*#__PURE__*/() => ({
  arrowPlacement
}) => arrowPlacement === 'top' ? '100%' : 'auto';
const _exp8 = /*#__PURE__*/() => ({
  arrowPlacement
}) => arrowPlacement === 'top' ? 'rotate(180deg)' : 'auto';
const _exp9 = /*#__PURE__*/() => ({
  large
}) => large ? '12px' : '8px';
const _exp0 = /*#__PURE__*/() => ({
  color,
  theme
}) => color === 'blue' ? '#007CFF' : theme.colors.icon.primary;
const TooltipArrow = withTheme(/*#__PURE__*/styled('div')({
  name: "TooltipArrow",
  class: "tfg515j",
  propsAsIs: false,
  vars: {
    "tfg515j-0": [_exp6()],
    "tfg515j-1": [_exp7()],
    "tfg515j-2": [_exp8()],
    "tfg515j-3": [_exp9()],
    "tfg515j-4": [_exp0()]
  }
}));

require("./Tooltip.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Tooltip.tsx");